import React from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { FilterComponentProps } from "../../../../Types/Miscellaneous.type";
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
export default function PlansaAndPricingFilterComponent({ onFilter, filterText, CreatePlanPage }: any) {


  return (
    <Row className="align-items-center justify-content-start">
      <Col xs="auto">
        <Button onClick={CreatePlanPage} class="btn btn-outline-primary-2x">Create</Button>
      </Col>
      
      <Col xs="auto" className="d-flex flex-row align-items-center gap-1">
      <Label>{"Search"}:</Label>
        <Input
          type="text"
          value={filterText}
          onChange={onFilter}
          placeholder="Filter by Plan Name ,users, "
        />
      </Col>
    </Row>
  );
}
